import React from 'react';
import Component from "./Component";
import { AppContext, ProgramProvider } from "../../../CEF/Providers";
var EligibilityButton = function EligibilityButton(props) {
  var openModalFn = props.openModalFn,
    eligibilityResult = props.eligibilityResult,
    userId = props.userId,
    programId = props.programId,
    _props$useUpdatedButt = props.useUpdatedButtonDesign,
    useUpdatedButtonDesign = _props$useUpdatedButt === void 0 ? false : _props$useUpdatedButt,
    variant = props.variant,
    fullWidth = props.fullWidth;
  var appContext = {
    userId: userId,
    programId: programId,
    studentId: null,
    lastButtonText: 'Continue'
  };
  return /*#__PURE__*/React.createElement(AppContext.Provider, {
    value: appContext
  }, /*#__PURE__*/React.createElement(ProgramProvider, null, /*#__PURE__*/React.createElement(Component, {
    openModalFn: openModalFn,
    result: eligibilityResult,
    useUpdatedButtonDesign: useUpdatedButtonDesign,
    variant: variant,
    fullWidth: fullWidth
  })));
};
export default EligibilityButton;